import InfoTooltip from 'components/_UI/InfoTooltip'
import Loader from 'components/_UI/Loader'
import Table from 'components/_UI/Table'
import Text from 'components/_UI/Text'
import date from 'helpers/date'
import React from 'react'
import { Info } from 'react-feather'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import colors from 'theme/colors'

export default function ListDrawer({
  giveaway,
  isLoading,
  toggleAction
}) {

  
  const listGiveaway = giveaway?.winners?.map((winner) => ({
    sorteado: (
      <Text key={winner?.id} name='small'>
        {winner?.user?.name}
      </Text>
    ),
    data: <Text name='small'>{date.format(giveaway?.created_at)}</Text>,
    action: (
      <ContentAction>
        <InfoTooltip
          bgColor={colors.night}
          text={'Visualizar detalhes do sorteio'}
          type='none'
        >
          <Info
            size={20}
            color={colors.primaryLight}
           
            onClick={() =>
              toggleAction({
                item: { giveaway, winner },
                type: 'detailDrawer',
              })
            }
          />
        </InfoTooltip>
      </ContentAction>
    ),
  }));

  return (
    <>
      <Column marginTop={'10px'}>
        <Row marginTop={'10px'} verticalCenter>
          <Text
      
            color={colors.nightDark}
            paddingBottom={'0px'}
            marginBottom={'0'}
            
            type='bold'
          >
            Nome do sorteio:
          </Text> 
          <Text marginLeft={'5px'} paddingBottom={'0px'}>{giveaway?.name}</Text>
        </Row>
        
        <Row>
            <Text type='bold' color={colors.nightDark}>Público do sorteio:</Text>
            <Text marginLeft={'5px'}>{giveaway?.scope == 'all' ?  'Todos os participantes ': 'Apenas quem fez check-in' } </Text>

        </Row>
      </Column>
      

      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Table
            rows={listGiveaway}
            columns={['Sorteado', 'Data', 'Ação']}
          />
        </>
      )}
    </>
  );
}

const ContentAction = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all ease-in-out 0.25s;

  & > div > svg {
    &:hover {
      transform: scale(1.1);
    }
  }
`
